import { startOfToday } from 'date-fns'
import { useState } from 'react'

import { EditDriverModal } from '@/components/DriversTable'
import { DateInput } from '@/components/ui/DateInput'
import { Field, FieldLabel } from '@/components/ui/field'
import { type Driver } from '@/models/driver'

interface DriverModalProps {
  driver: Driver
  isNew: boolean
  existing: Driver[]
  initialFirstDrive?: Date
  onClose: () => void
  /** Rejects with the API's error, which the form shows on its fields. */
  onSubmit: (driver: Driver, firstDrive: Date | undefined) => Promise<void>
}

/** The Drivers page's form with a new driver's first scheduled drive. */
export function DriverModal({
  driver,
  isNew,
  existing,
  initialFirstDrive,
  onClose,
  onSubmit,
}: DriverModalProps) {
  const [firstDrive, setFirstDrive] = useState<Date | undefined>(initialFirstDrive)

  return (
    <EditDriverModal
      driver={driver}
      existingDrivers={existing}
      onClose={onClose}
      onSubmit={(edited) => onSubmit(edited, firstDrive)}
      enforceCarrierRequired
      isNew={isNew}
      hideOwnerToggle
    >
      <Field>
        <FieldLabel htmlFor="driver-first-drive" optional>
          First scheduled drive
        </FieldLabel>
        <DateInput
          value={firstDrive}
          onChange={setFirstDrive}
          hidden={{ before: startOfToday() }}
          inputProps={{ id: 'driver-first-drive' }}
        />
      </Field>
    </EditDriverModal>
  )
}
